import {
    List,
    ItemRevenue,
    MonthlySalePurchase,
    LedgerDetails,
    LedgerItemsDetails,
    LedgerTransactionDetails,
    CompanyWiseBill,
    OfficerBill,
    DayBook,
    MonthlyLedger,
    DisplayVoucher,
    Groups,
    GroupLedger,
    MyBillDetails,
    Stock,
    ItemsVoucherDetails,
    AuditList,
    AuditSheet,
    AuditStock,
    AuditAsset,
    AuditSheetMonthly,
    ProductionCost,
    ProductionCostDetails,
    LedgerEMIDetails,
    Dashboard,
    AuditLedgerDetails,
    YearlyLedger,
    BalanceSheet,
} from "../Components/index.js";

export default [
    {
        path: "/report/bq-store/dashboard",
        component: Dashboard,
        name: "report.bq-store.dashboard",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/bq-store/monthly-sales-purchase-profit",
        component: MonthlySalePurchase,
        name: "report.bq-store.sales",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/bq-store/revenue",
        component: List,
        name: "report.bq-store.revenue.monthly",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/bq-store/monthly/sale-purchase",
        component: ItemRevenue,
        name: "report.bq-store.item.revenue.monthly",
        meta: {
            requiresAuth: true,
        },
    },

    // Stock
    {
        path: "/report/bq-store/stock",
        component: Stock,
        name: "report-bq-store-inventory-stock",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/bq-store/production-cost",
        component: ProductionCost,
        name: "report.bq-store.production",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/bq-store/production-cost/:id",
        component: ProductionCostDetails,
        name: "report.bq-store.production.details",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/bq-store/day-book",
        component: DayBook,
        name: "report-bq-store-inventory-daybook",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/bq-store/day-book-removed",
        component: DayBook,
        name: "report.bq-store.inventory.daybook.removed",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/bq-store/sales/:id/view",
        component: DisplayVoucher,
        name: "report.bq-sale.view",
        meta: {
            requiresAuth: true,
        },
    },

    //Account Info
    {
        path: "/report/bq-store/item-voucher-details",
        component: ItemsVoucherDetails,
        name: "report.bq-store.product.voucher.details",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/bq-store/ledger",
        component: LedgerDetails,
        name: "report.bq-store.LedgerDetails",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/bq-store/monthly-ledger/:id",
        component: MonthlyLedger,
        name: "report.bq-store.MonthlyLedger",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/bq-store/yearly-ledger/:id",
        component: YearlyLedger,
        name: "report.bq-store.yearly.ledger",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/bq-store/ledger-items",
        component: LedgerItemsDetails,
        name: "report.bq-store.LedgerItemDetails",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/bq-store/ledger-details",
        component: LedgerTransactionDetails,
        name: "report.bq-store.LedgerTranDetails",
        meta: {
            requiresAuth: true,
        },
    },

    // My Bill
    {
        path: "/report/bq-store/my-bq-store-bill-details",
        component: MyBillDetails,
        name: "report.my.bq-store.details",
        meta: {
            requiresAuth: true,
        },
    },

    //Account Group
    {
        path: "/report/bq-store/group",
        component: Groups,
        name: "report.bq-store.group",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/bq-store/group/:id",
        component: GroupLedger,
        name: "report.bq-store.group.ledger",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/bq-store/group-emi",
        component: LedgerEMIDetails,
        name: "report.bq-store.group.ledger.emi",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/bq-store/ledger/:id",
        component: GroupLedger,
        name: "report.bq-store.ledger",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/bq-store/company-wise-bill",
        component: CompanyWiseBill,
        name: "report.bq-store.company.bill",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/bq-store/officer-bill",
        component: OfficerBill,
        name: "report.bq-store.officer.bill",
        meta: {
            requiresAuth: true,
        },
    },

    // Audit Section
    {
        path: "/report/bq-store/audit-monthly",
        component: AuditSheetMonthly,
        name: "report.bq-store.audit.monthly",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/bq-store/audit-sheet",
        component: AuditList,
        name: "report.bq-store.audit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/bq-store/audit-sheet/:id",
        component: AuditSheet,
        name: "report.bq-store.audit.details",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/bq-store/audit-stock",
        component: AuditStock,
        name: "report.bq-store.audit.stock",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/bq-store/audit-asset",
        component: AuditAsset,
        name: "report.bq-store.audit.asset",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/reports/bq-store/audit-ledger",
        component: AuditLedgerDetails,
        name: "report.bq-store.audit-ledger",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/reports/bq-store/balance-sheet",
        component: BalanceSheet,
        name: "balance.bq.store.sheet",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/reports/bq-store/voucher-print",
        component: () => import("../Components/VoucherPrint.vue"),
        name: "bq-store-voucher-print",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/reports/bq-store/other-print",
        component: () => import("../Components/OthersVoucherPrint.vue"),
        name: "bq-store-others-voucher-print",
        meta: {
            requiresAuth: true,
        },
    },
];
